<template>
  <v-chart v-if="ready" :options="graph"/>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/treemap'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

export default {
  name: 'tree-map-cost',
  components: {'v-chart': ECharts},
  props: ['data'],
  data() {
    return {
      ready: false,
      graph : {
        tooltip: {
          show: true
        },
        title : {
          text: 'Costos Comerciales',
          x:'left',
          top:5,
          padding:0
        },
        grid: {
          top:0
        },
        textStyle: {
          fontFamily: 'Gotham',
          color: '#888'
        },
        legend: {
          show: true,
          data:['Flete', 'Acondicionamiento', 'Otros']
        },
        series: [{
          type: 'treemap',
          width: '100%',
          height: '88%',
          levels: [{},
            {
              itemStyle: {
                borderWidth: 2,
                borderColor: '#ddd'
              }
            }],

          upperLabel: {
            show:true,
            padding:3,
            fontWeight: 'bold',
            color: '#002'
          },
          itemStyle: {
            color:'red'
          },
          breadcrum: {
            show: true
          },
          data: [{
            name: 'Flete (USD/Ha)',            // First tree
            value: function() {
              return parseInt(this.data['com_flete_corto']) + parseInt(this.data['com_flete_largo'])
            },
            label: {
              show: true,
            },
            children: [{
              name: 'Flete corto',       // First leaf of first tree
              value: this.data['com_flete_corto']
            }, {
              name: 'Flete largo',       // Second leaf of first tree
              value: this.data['com_flete_largo']
            }]
          },
          {
            name: 'Acondicionamiento (USD/Ha)',            // Second tree
            value: function() {
              return parseInt(this.data['com_acon_sec']) + parseInt(this.data['com_acon_zar']) + parseInt(this.data['com_acon_mer']) + parseInt(this.data['com_acon_cal']) + parseInt(this.data['com_acon_otros'])
            },
            children: [{
              name: 'Secada',       // First leaf of first tree
              value: this.data['com_acon_sec']
            }, {
              name: 'Zaranda',       // Second leaf of first tree
              value: this.data['com_acon_zar']
            },{
              name: 'Merma',       // Second leaf of first tree
              value: this.data['com_acon_mer']
            },
            {
              name: 'Calidad',       // Second leaf of first tree
              value: this.data['com_acon_cal']
            },

            {
              name: 'Otros',       // Second leaf of first tree
              value: this.data['com_acon_otros']
            }]
          },
          {
            name: 'Otros (USD/Ha)',            // Second tree
            value: function() {
              return parseInt(this.data['com_otro_com']) + parseInt(this.data['com_otro_par']) + parseInt(this.data['com_otro_alm'])
            },
            children: [{
              name: 'Comisión',       // First leaf of first tree
              value: this.data['com_otro_com']
            }, {
              name: 'Paritaria',       // Second leaf of first tree
              value: this.data['com_otro_par']
            },
            {
              name: 'Almacenamiento',       // Second leaf of first tree
              value: this.data['com_otro_alm']
            }]
          }]
        }]
      }

    }
  },
  mounted() {
    this.$nextTick(function() {
      this.ready = true;
    })

  }
}
</script>
